import { all } from 'redux-saga/effects';
import getManagerLeadsSaga from './get_manager_leads.saga';
import setManagerLeadManagePaginationSaga from './set_manager_lead_manage_pagination.saga';
import changeManagerLeadStatusSaga from './lead_manager_get_lead_status.saga';

export default function* managerLeadsRootSaga() {
    yield all([
        getManagerLeadsSaga(),
        setManagerLeadManagePaginationSaga(),
        changeManagerLeadStatusSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/sagas/manager_leads_root.saga.js